import * as z from 'zod';

import { validaNomeCompleto } from '../../../../utils/ValidaNome';

export const empresaSchema = z.object({
  cnpj: z.optional(
    z
      .string()
      .min(18, { message: 'Campo obrigatório' })
      .regex(/^(?!\d{18})\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/, {
        message: 'CNPJ inválido',
      }),
  ),
  razaoSocial: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
  Responsavel: z.object({
    cpf: z.optional(
      z
        .string()
        .min(14, { message: 'Campo obrigatório' })
        .regex(/^(?!\d{11})\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/, {
          message: 'CPF inválido',
        }),
    ),
    nome: z.string().refine(val => validaNomeCompleto(val), {
      message: 'Digite o nome completo sem abreviações (ex: João da Silva)',
    }),
    email: z.string().email(),
    telefone: z.string(),
  }),
  address: z.optional(
    z.object({
      cep: z.optional(
        z
          .string()
          .min(9, { message: 'Campo obrigatório' })
          .regex(/^[0-9]{5}-[0-9]{3}$/, { message: 'CEP inválido' }),
      ),
      neighborhood: z.optional(
        z.string().min(1, { message: 'Campo obrigatório' }),
      ),
      uf: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
      city: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
      street: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
      number: z.optional(
        z
          .string()
          .min(1, { message: 'Campo obrigatório' })
          .regex(/^\d+$/, { message: 'Deve conter apenas números' }),
      ),
      complement: z.optional(z.string()),
    }),
  ),
});

export type EmpresaSchema = z.infer<typeof empresaSchema>;
